<!-- Exports tab – card-per-export layout matching compare-report-view #reportTemplate -->
<div class="flex flex-col gap-3 p-3 overflow-y-auto h-full scrollbar-thin">
    @for (item of exportItems; track item.title; let i = $index) {
    <div class="flex flex-col gap-2 border-2 border-gray-200 rounded-base p-3" [class.opacity-60]="!item.action">

        <!-- Title + action buttons -->
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
                <i [class]="item.icon + ' text-gray-600'"></i>
                <span class="text-sm font-bold">{{ item.title }}</span>
            </div>

            <div class="flex items-center gap-1">
                <!-- Preview — hidden for XLSX items -->
                @if (supportsMode(item, 'preview')) {
                <app-button icon="pi pi-eye" severity="contrast"
                    [disabled]="!item.action || isLoading(i, 'preview') || isLoading(i, 'download') || isLoading(i, 'open')"
                    [loading]="isLoading(i, 'preview')" pTooltip="Preview" tooltipPosition="bottom"
                    (clicked)="onAction(item, i, 'preview')" />
                }

                <!-- Download -->
                @if (supportsMode(item, 'download')) {
                <app-button icon="pi pi-download" severity="contrast"
                    [disabled]="!item.action || isLoading(i, 'preview') || isLoading(i, 'download') || isLoading(i, 'open')"
                    [loading]="isLoading(i, 'download')" pTooltip="Download" tooltipPosition="bottom"
                    (clicked)="onAction(item, i, 'download')" />
                }

                <!-- Open in new tab — hidden for XLSX items -->
                @if (supportsMode(item, 'open')) {
                <app-button icon="pi pi-external-link" severity="contrast"
                    [disabled]="!item.action || isLoading(i, 'preview') || isLoading(i, 'download') || isLoading(i, 'open')"
                    [loading]="isLoading(i, 'open')" pTooltip="Open in new tab" tooltipPosition="bottom"
                    (clicked)="onAction(item, i, 'open')" />
                }
            </div>
        </div>

        <!-- Description + format + status -->
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-600">{{ item.description }}</span>
            <div class="flex items-center justify-between">
                <span class="text-xs font-light text-gray-400">
                    Formats Available: {{ item.formats }}
                </span>
                @if (!item.action) {
                <span class="text-xs text-amber-500 font-medium">Coming soon</span>
                }
            </div>
        </div>

    </div>
    }
</div>

<!-- OnlyOffice XLSX preview dialog (Resource Cost Breakdown and future XLSX exports) -->
<app-dialog [visible]="xlsxPreviewVisible" [title]="xlsxPreviewTitle"
    (closed)="xlsxPreviewVisible = false" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="h-[80vh]">
            <app-only-office-doc-editor
                editorId="exportXlsxPreview"
                [configData]="xlsxEditorConfig"
                class="h-full w-full block">
            </app-only-office-doc-editor>
        </div>
    </ng-template>
</app-dialog>

<!-- Preview dialog — renders PDF viewer or sandboxed iframe depending on content type -->
<app-dialog [visible]="previewVisible" [title]="previewTitle" (closed)="onPreviewClose()" class="max-w-[80vw] w-[80vw]">
    <ng-template #bodyTemplate>
        <div class="h-[75vh]">
            @if (previewType === 'html' && previewHtmlSrc) {
            <!-- Sandboxed iframe for HTML exports (e.g. AI Dashboard) -->
            <iframe
                [src]="previewHtmlSrc"
                class="w-full h-full border-0 rounded"
                sandbox="allow-scripts allow-same-origin"
                title="AI Dashboard Preview">
            </iframe>
            } @else {
            <!-- Standard PDF viewer for Report Summary / Analysis Summary -->
            <app-pdf-viewer class="h-full w-full" [pdfUrl]="previewUrl" [hideToolbar]="false">
            </app-pdf-viewer>
            }
        </div>
    </ng-template>
</app-dialog>
